import React from 'react';
import Image from '../../src/assets/images/loader.png'; 

const SuccessLoader = () => {
    return (
        <div className="success-overlay">
            <img src={Image} alt="Success" className="success-icon" />
        </div>
    );
};

export default SuccessLoader;